const DoubtAnswer = {
    YES: 1,
    NO: 2,
}
export default DoubtAnswer;
